import { render, staticRenderFns } from "./checkPage.vue?vue&type=template&id=3b8335d8&scoped=true&"
import script from "./checkPage.vue?vue&type=script&lang=js&"
export * from "./checkPage.vue?vue&type=script&lang=js&"
import style0 from "./checkPage.vue?vue&type=style&index=0&id=3b8335d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8335d8",
  null
  
)

export default component.exports